import { createGlobalStyle } from 'styled-components';
import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: [
      'Source Sans 3:300,400,500,600,700&display=swap',
      'Source Serif 4:400,500,600,700&display=swap',
    ],
  },
});

export const GlobalStyle = createGlobalStyle`
  :root {
    --global-bg-color: #ffffff;
    --global-card-bg-color: #ffffff;
    --global-code-bg-color: rgba(0, 118, 223, 0.06);
    --global-text-color: #000000;
    --global-text-color-light: #828282;
    --global-theme-color: #0076df;
    --global-highlight-color: #b71c1c;
    --global-divider-color: rgba(0, 0, 0, 0.1);
  }

  *, *::before, *::after {
    box-sizing: border-box;
    border: 0;
    padding: 0;
    margin: 0;
  }
   
  html, body {
    font-size: 62.5%;
    min-height: 100%;
  }
  
  body {  
    background: var(--global-bg-color);
    color: var(--global-text-color);
    margin: 0;
    padding: 0;
    font-family: 'Source Sans 3', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 1.6rem;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  #root {
    min-height: 100%;
  }

  button,
  input {
    font-family: inherit;
  }
`;

export default GlobalStyle;
